import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const linkStyle = {
    color: 'white',
    textDecoration: 'none',
    padding: '0.75rem 1rem',
    display: 'block',
    borderRadius: '4px'
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f7fa' }}>
      <style>{`
        @media (max-width: 767px) {
          .mobile-menu-btn { display: block !important; }
          .main-nav.closed { display: none !important; }
          .main-nav.open { display: block !important; }
          .main-nav .nav-links { flex-direction: column; }
          .welcome-text { display: none !important; }
          .header-logo { max-height: 40px !important; }
        }
        @media (min-width: 768px) {
          .mobile-menu-btn { display: none !important; }
          .main-nav { display: block !important; }
          .main-nav .nav-links { flex-direction: row; }
        }
        .nav-link:hover { background: rgba(255, 255, 255, 0.15); }
      `}</style>

      <header style={{ background: 'linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)', color: 'white', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to="/dashboard" style={{ textDecoration: 'none' }}>
            <img
              src="/logo.png"
              alt="Goodwin Barrett"
              className="header-logo"
              style={{
                height: '50px',
                display: 'block',
                filter: 'brightness(0) invert(1)',
                WebkitFilter: 'brightness(0) invert(1)'
              }}
            />
          </Link>
          {user && (
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <span className="welcome-text" style={{ fontSize: 'clamp(0.85rem, 2vw, 1rem)', fontWeight: '500' }}>
                Welcome, {user.first_name}
              </span>
              <button
                onClick={handleLogout}
                style={{
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  background: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '6px',
                  fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                  fontWeight: '500',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {user && (
        <>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="mobile-menu-btn"
            style={{
              display: 'none',
              background: '#5B9BD5',
              color: 'white',
              border: 'none',
              padding: '1rem',
              fontSize: '1.5rem',
              cursor: 'pointer',
              width: '100%',
              textAlign: 'left'
            }}
          >
            {menuOpen ? '✕ Close Menu' : '☰ Menu'}
          </button>

          <nav className={`main-nav ${menuOpen ? 'open' : 'closed'}`} style={{ background: 'linear-gradient(135deg, #5B9BD5 0%, #4A90E2 100%)', padding: '0.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <div className="nav-links" style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', gap: '0.5rem' }}>
              <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="nav-link" style={linkStyle}>Dashboard</Link>
              <Link to="/claims" onClick={() => setMenuOpen(false)} className="nav-link" style={linkStyle}>My Claims</Link>
              <Link to="/communications" onClick={() => setMenuOpen(false)} className="nav-link" style={linkStyle}>Communications</Link>
              <Link to="/uploads" onClick={() => setMenuOpen(false)} className="nav-link" style={linkStyle}>Upload Documents</Link>
              <Link to="/faqs" onClick={() => setMenuOpen(false)} className="nav-link" style={linkStyle}>FAQs</Link>
            </div>
          </nav>
        </>
      )}

      <main style={{ flex: 1, maxWidth: '1200px', margin: '2rem auto', padding: '0 1rem', width: '100%' }}>
        {children}
      </main>

      <footer style={{ background: 'linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)', color: 'white', padding: '1.5rem', textAlign: 'center' }}>
        <p style={{ margin: 0, fontSize: 'clamp(0.85rem, 2vw, 1rem)', fontWeight: '500' }}>© 2025 Goodwin Barrett. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Layout;
